import quanfangweiImg from 'images/eyes/quanfangwei.png';
import shiwangmoImg from 'images/eyes/shiwangmo.png';
import shishenjingImg from 'images/eyes/shishenjing.png';
import baineizhangImg from 'images/eyes/baineizhang.png';

export type AdultCheckupReportType = 'quanfangwei' | 'shiwangmo' | 'shishenjing' | 'baineizhang';

export interface AdultCheckupReportOption {
	slug: AdultCheckupReportType;
	/** 顯示名稱，亦為 API `eye_image_type` 參數 */
	title: string;
	eyesHeType: string;
	imageSrc: string;
}

export const ADULT_CHECKUP_REPORT_OPTIONS: AdultCheckupReportOption[] = [
	{
		slug: 'quanfangwei',
		title: '全方位健檢',
		eyesHeType: '全方位健檢',
		imageSrc: quanfangweiImg,
	},
	{
		slug: 'shiwangmo',
		title: '視網膜健檢',
		eyesHeType: '視網膜健檢',
		imageSrc: shiwangmoImg,
	},
	{
		slug: 'shishenjing',
		title: '視神經健檢',
		eyesHeType: '視神經健檢',
		imageSrc: shishenjingImg,
	},
	{
		slug: 'baineizhang',
		title: '白內障健檢',
		eyesHeType: '白內障健檢',
		imageSrc: baineizhangImg,
	},
];

export const getAdultCheckupOptionBySlug = (
	slug: string,
): AdultCheckupReportOption | undefined =>
	ADULT_CHECKUP_REPORT_OPTIONS.find(option => option.slug === slug);

export const isValidAdultCheckupReportType = (
	slug: string,
): slug is AdultCheckupReportType => !!getAdultCheckupOptionBySlug(slug);
